class RoutesName {
  static HOME = "/";
  static STUDBOOK = "/studbook";
  static AUCTIONS = "/auctions";
  static SINGLE_AUCTION = "/singleauction";
  static AUCTION = "/auction";
  static OWNER_DETAILS = "/ownerdetails";
  static HORSE_DETAILS = "/horsedetails";
  static HORSE_MARKET_PROFILE = "/horsemarketprofile";
  static LOGIN = "/login";
  static LOGIN_UAE_PASS = "/loginuaepass";
  static UAE_PASS_OTP = "/uaepassotp";
  static REGISTER = "/register";
  static HORSE_AUCTION = "/horse-auction";
  static BIDDING = "/bidding";
  static FULL_SCREEN_BIDDING = "/fullScreenBidding";
  static HYBRID_BIDDING = "/hybridBidding";
  static PROFILE = "/profile";
  static HORSE_MARKET = "/horsemarket";
  static SHOWS = "/shows";
  static SHOW_DETAILS = "/showdetails";
  static FORGET_PASSWORD = "/forgetpassword";
  static SINGLE_SERVICE = "/singleservice";
  static SINGLE_POST = "/singlePost";
  static ABOUT_US = "/about-us";
  static NEWS = "/news";
  static HORSE_SUPPLIES = "/horseSupplies";
  static SINGLE_SUPPLIER = "/SingleSupplier";
  static JUDGES_PAGE = "/JudgesPage";
  static PRESIDENT_WORD = "/presidentWord";
  static LIBRARY_PAGE = "/libraryPage";
  static HORSE_TRANSPORT_COMPANIES = "/HorseTransportCompanies";
  static SINGLE_TRANSPORT_COMPANY = "/SingleTransportCompany";
  static HORSE_HOSPITALS = "/HorseHospitals";
  static SINGLE_HOSPITAL = "/SingleHospital";
  static EQUESTRIAN_CENTERS_CLUBS = "/EquestrianCentersClubs";
  static SINGLE_EQUESTRIAN_CENTERS_CLUBS = "/SingleEquestrianCentersClubs";
  static CONTACT_US = "/contactus";
  static SERVICES = "/services";
  static ORG_CHART = "/orgChart";
  static WAHO_CONFERENCE = "/wahoconference";
  static M_WAHO_CONFERENCE = "/m-wahoconference";
  static SHOW_ENTRY_CARD = "/showentrycard";
  static CALENDAR = "/calendar";
  static ADD_EARLY_YEARLING_HORSE = "/addEarlyYearlingHorse";
  static SHOW_ENTRY_DETAILS = "/showentrydetails";
  static ADD_REGISTER_HORSE = "/addRegisterHorse";
  static SHOW_ENTRY_CONFLICT = "/showentryconflict";
  static COURSES = "/courses";
  static COURSE_DETAILS = "/courseDetails";
  static COURSE_ENROLLMENT = "/courseEnrollment";
  static COURSE_ENROLLMENT_DATE = "/courseEnrollmentDate";
  static SPONSORS_PAGE = "/sponsorsPage";
  static SHOW_ENTRY_TOTAL_REGISTERED_HORSES = "/showentrytotalregisteredhorses";
  static SHOW_ENTRY_PARTICIPANTS_REQUEST = "/showentryparticipantsrequest";
  static SHOW_ENTRY_SUBMISSION_SUCCESSFUL = "/showentrysubmissionsuccessful";
  static GALLERY = "/gallery";
  static ALBUM_DETAILS = "/album-details";
  static WAHO_TROPHY = "/waho-trophy";
  static BOOK_TABLE = "/book-table";
  static ADS_BOOK_TABLE = "/ads-book-table";
  static OPEND_EVENTS = "/opend-events";
  static OPEND_ADS = "/opend-ads";
  static SHOWS_CATEGORIES = "/shows-categories";
  static NONE_ECAHO_SHOWS_CATEGORIES = "/none-ecaho-shows-categories";
  static AUCTION_ENTRY_CARD = "/auctionentrycard";
  static EAHS_AWARD = "/eahs-award";
  static OPEN_APP_OR_STORE = "/openAppOrStore";
  static AUCTION_ENTRY_TOTAL_REGISTERED_HORSES = "/auctionentrytotalregisteredhorses";
  static AUCTION_ENTRY_SUBMISSION_SUCCESSFUL = "/auctionentrysubmissionsuccessful";
  static BOOKING_SUCCESSFUL = "/bookingsuccessful";
  static REQUEST_HORSE_OWNERSHIP_TRANSFER_SELLER = "/requestHorseOwnershipTransferSeller";
  static SERVICES_REQUESTS_PAYMENT_SUCCESSFUL = "/servicesrequestspaymentsuccessful";
  static EDUCATIONAL_COURSES = "/Educational-Courses";
  static ADD_INTERNATIONAL_HORSE = "/addInternationalHorse";
  static SHOW_ENTRY_CHECKOUT_PAGE = "/showEntryCheckoutPage";
  static SINGLE_TERMS_AND_CONDITIONS_SHOW_PAGE = "/SingleTermsAndConditionsShowPage";
  static ADD_ORGANIZER_REQUEST = "/add-organizer-request";
  static SHOW_CATALOG = "/ShowCatalog";
  static NOT_FOUND_404 = "/404-not-found";
  static NOT_AUTHORIZED_403 = "/403-Not-Authrized";
  static LIVE_EVENT = "/live-event";
  static REQUEST_COVERING_CERTIFICATE = "/requestCoveringCertificate";
  static REQUEST_EMBRYO_OOCYTE_TRANSFER_PERMIT = "/requestEmbryoOocyteTransferPermit";
  static REQUEST_EMBRYO_TRANSFER_RIGHT_PURCHASE_AGREEMENT = "/requestEmbryoTransferRightPurchaceAgreement";
  static REQUEST_REGISTERING_NEW_ARABIAN_HORSE_FOAL = "/requestRegisteringNewArabianHorseFoal";
  static REQUEST_OWNED_HORSES_CERTIFICATE = "/requestForOwnedEAHSRegisteredHorsesCertificate";
  static REQUEST_REGISTER_ARABIAN_HORSE_STUD = "/requestForRegistrationOfAnArabianHorseStud";
  static REQUEST_UPDATE_HORSE_DATA = "/requestToUpdateArabianHorseData";
  static REQUEST_HORSE_DEATH_DECLARATION = "/requestToDeclarationOfArabianHorseDeath";
  static INACTIVE_HORSE_REGISTRATION_REQUEST = "/inactiveHorseRegistrationRequest";
  static REQUEST_RACING_NAME_IMPORTED_HORSE = "/requestToAddARacingNameForAnImportedArabianHorse";
  static REQUEST_PASSPORT_DUPLICATE_DAMAGED = "/reqestForIssuingAnArabianHorsePassportDuplicateDamaged";
  static IMPORT_HORSE_FROZEN_SEMEN = "/importHorseFrozenSemen";
  static IMPORT_HORSE = "/importHorse";
  static GENETIC_DISORDER_TESTING = "/geneticDisorderTesting";
  static REQUEST_SEMEN_CERTIFICATE = "/requestSemenCertificate";
  static EXPORT_HORSE = "/exportHorse";
  static CANCEL_EXPORT_HORSE = "/cancelExportHorse";
  static EXPORT_HORSE_SEMEN = "/exportHorseSemen";
  static PRESS_COVERAGE_REQUEST = "/pressCoverageRequest";
  static M_OPEND_EVENTS = "/m-opend-events";
  static M_OPEND_ADS = "/m-opend-ads";
  static M_BOOK_TABLE = "/m-book-table";
  static M_ADS_BOOK_TABLE = "/m-ads-book-table";
  static SHOW_PARTICIPATE = "/showParticipate";
  static AUCTION_PARTICIPATE = "/auctionParticipate";
  static AUCTION_ENTRY_CHECKOUT_PAGE = "/auctionEntryCheckout";
  static CHULIBPAGE = "/chulibregitration";
  static OWNERSSERVICEFORM = "/ownerServicesForm";
  static SEMENMARKET = "/semenMarket";
  static SEMENDETAILS = "/semenDetails";
  static SEMENCHECKOUT = "/semenCheckout";
}
export default RoutesName;